/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Draw from '@arcgis/core/views/draw/Draw';
import SketchViewModel from '@arcgis/core/widgets/Sketch/SketchViewModel';
import {loadModules} from 'esri-loader';
import {error} from '@ion/core/src/logger/logger';

/**
 * @initializeDrawingTools
 *
 * Provides an async utility initializing the esri drawing tools
 *
 * ```typescript
 *
 *   import {initializeDrawingTools} from '@ion/dls/src/maps/hooks';
 *
 *   async function initializeTools () {
 *     const [
 *        Draw,
 *        Graphic,
 *        GraphicsLayer,
 *        SketchViewModel
 *     ] = await initializeDrawingTools();
 *   }
 *
 * ```
 *
 */
function initializeDrawingTools(isFMTracking: boolean = false): Promise<any> {
  return new Promise((resolve, reject) => {
    if (!isFMTracking) {
      loadModules([
        'esri/views/draw/Draw',
        'esri/Graphic',
        'esri/layers/GraphicsLayer',
        'esri/widgets/Sketch/SketchViewModel'
      ])
        .then(
          ([
            Draw,
            Graphic,
            GraphicsLayer,
            SketchViewModel]) => {
            resolve([
              Draw,
              Graphic,
              GraphicsLayer,
              SketchViewModel
            ]);
          })
        .catch(err => {
          reject(error(err));
        });
    } else {
      resolve([
        Draw,
        Graphic,
        GraphicsLayer,
        SketchViewModel
      ]);
    }
  });
};

export default initializeDrawingTools;
